const doc = [({"ja":({"adminConstantHotelDisplayCalendarType":({"displayed":"表示する", "hidden":"表示しない", "hideButton":"料金を見るボタン非表示"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;